/*
 * Copyright 2023 Comcast Cable Communications Management, LLC
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { type Stage } from '@lightningjs/renderer';

export async function installShaders(stage: Stage, renderMode: string) {
  let shaders;
  if (renderMode === 'webgl') {
    shaders = await import('@lightningjs/renderer/webgl/shaders');
  } else if (renderMode === 'canvas') {
    shaders = await import('@lightningjs/renderer/canvas/shaders');
  }
  stage.shManager.registerShaderType('Rounded', shaders.Rounded);
  stage.shManager.registerShaderType(
    'RoundedWithBorder',
    shaders.RoundedWithBorder,
  );
  stage.shManager.registerShaderType(
    'RoundedWithShadow',
    shaders.RoundedWithShadow,
  );
  stage.shManager.registerShaderType(
    'RoundedWithBorderAndShadow',
    shaders.RoundedWithBorderAndShadow,
  );
  stage.shManager.registerShaderType('Border', shaders.Border);
  stage.shManager.registerShaderType('Shadow', shaders.Shadow);
  stage.shManager.registerShaderType('HolePunch', shaders.HolePunch);
  stage.shManager.registerShaderType('RadialGradient', shaders.RadialGradient);
  stage.shManager.registerShaderType('LinearGradient', shaders.LinearGradient);
}
